/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiLoadSpinnerIcon20Regular = forwardRef('UiLoadSpinnerIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M10 3.501a6.499 6.499 0 1 0 6.499 6.5.75.75 0 0 1 1.5 0A7.999 7.999 0 1 1 10 2a.75.75 0 0 1 0 1.5Z" })));
});
